var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"0.42em","height":"1em","viewBox":"0 0 160 384"}},[_c('path',{attrs:{"d":"M158 94l-98 98l98 98l-30 30L0 192L128 64z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }